/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader[_ngcontent-%COMP%]{border:6px solid #f3f3f3;border-radius:50%;border-top:6px solid #036;width:51px;height:51px;-webkit-animation:1.2s cubic-bezier(.5,0,.5,1) infinite spin;animation:1.2s cubic-bezier(.5,0,.5,1) infinite spin}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0)}100%{-webkit-transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}"];
export { styles as styles };
